import React from 'react';
import { Bars3Icon, ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/images/logo.svg';

export default function Header({ onToggleSidebar }) {
  const { admin, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <header className="shadow-sm border-b border-green-500" style={{ backgroundColor: '#3ee851' }}>
      <div className="flex items-center justify-between px-6 py-4">
        <div className="flex items-center gap-4">
          <button
            onClick={onToggleSidebar}
            className="p-2 rounded-lg text-black hover:bg-black/10"
          >
            <Bars3Icon className="h-6 w-6" />
          </button>
          <img src={logo} alt="Bizumia" className="h-8" />
        </div>

        <div className="flex items-center gap-4">
          <div className="text-right">
            <p className="text-sm font-medium text-black">{admin?.name}</p>
            <p className="text-xs text-black/70 font-medium">{admin?.role?.name}</p>
          </div>
          <button
            onClick={handleLogout}
            className="p-2 rounded-lg text-black hover:bg-[#FF3332] hover:text-white transition-colors"
            title="Logout"
          >
            <ArrowRightOnRectangleIcon className="h-6 w-6" />
          </button>
        </div>
      </div>
    </header>
  );
}
